import React, { useState, useEffect } from "react";
import "../styles/TeacherTagList.css";
import { teacherTagPercentage } from "../Services/AllServices";
import { getUserID } from "../Storage/Storage";

const TagItem = ({ name, progress }) => (
  <div className="tag-item">
    <div className="tag-name">{name}</div>
    <div className="tag-name-tooltip">{name}</div>
    <div className="progress-bar-container">
      <div className="progress-bar" style={{ width: `${progress}%` }} />
    </div>
  </div>
);

const TeacherTagsList = () => {
  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    const fetchTagPercentage = async () => {
      try {
        const userId = await getUserID();
        const formData = { user_id: userId };

        await teacherTagPercentage(formData, (response) => {
          if (response && response.status === "success") {
            const { totalTags, tag_percentages } = response.data;

            // Create a tag list with name and percentage
            const tagsWithProgress = Object.keys(totalTags).map((tag) => {
              return {
                name: tag.trim(), // Trim whitespace from tag name
                progress: tag_percentages[tag] || 0, // Get percentage or 0 if not found
              };
            });

            // Sort tags by progress in descending order
            tagsWithProgress.sort((a, b) => b.progress - a.progress);

            //console.log(tagsWithProgress); // Logging the updated tags
            setTagList(tagsWithProgress);
          }
        });
      } catch (error) {
        console.error("Failed to fetch tags progress", error);
      }
    };

    fetchTagPercentage();
  }, []);

  return (
    <div className="tags-container">
      <h1>Tags</h1>
      <div className="tags-list">
        {tagList.map((tag, index) => (
          <TagItem key={index} name={tag.name} progress={tag.progress} />
        ))}
      </div>
    </div>
  );
};

export default TeacherTagsList;
